module.exports = __webpack_public_path__ + "img/img-4.9e7a696c.jpg";